export const MEETING_ROOM_RESERVATION_PATH = '/meeting-room-reservation/:id';
